import React, { useState } from 'react';
import { ChevronDown } from '../../../../assets/icons/ChevronDown';
import { CircleCrossSmallIcon } from '../../../../assets/icons/CircleCrossSmallIcon';
import { CircleTickFilledIcon } from '../../../../assets/icons/CircleTickFilledIcon';
import { CircleMinusIcon } from '../../../../assets/icons/CircleMinusIcon';

export interface AccordionPanel {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  subtitle?: string;
}

export interface ProtectionDetailsAccordionPanelWibProps {
  panels?: { title: string; description?: string; additionalContent?: string }[];
  isDesktop?: boolean;
  warrantyLength?: number;
  currentWarrantyLabel?: string;
  quoteCoverageLabel?: string;
}

const styles = {
  headingLabel:
    'text-[11px] tablet:text-body-small-strong leading-tight text-neutral-900 text-center w-16 tablet:w-20 flex items-center justify-center font-bold',
};

export function BenefitsTableAccordion({ panels = [] }: ProtectionDetailsAccordionPanelWibProps) {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const togglePanel = (index: number) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  return (
    <>
      <div className="flex justify-end gap-space-200 tablet:gap-space-400 mb-2 pr-1">
        <h5 className={styles.headingLabel}>Current Warranty</h5>
        <h5 className={styles.headingLabel}>Hisense Care Plus</h5>
      </div>

      {panels.map((panel, index) => {
        const expanded = expandedIndex === index;
        return (
          <div
            key={index}
            className={`flex items-start w-full cursor-pointer
              ${index === 0 ? 'py-space-300' : 'py-space-300 border-t border-card-border-neutral'}`}
            onClick={() => togglePanel(index)}
            role="button"
            aria-expanded={expanded}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                togglePanel(index);
              }
            }}
          >
            <div className="flex flex-col w-full">
              <div className="flex flex-row gap-space-200 items-baseline w-full">
                <ChevronDown
                  isOpen={expanded}
                  className="text-neutral-900 text-body-strong transition-transform duration-250 linear mr-space-200 shrink-0"
                  aria-hidden="true"
                />

                <div className="flex flex-col flex-1">
                  <p className="text-left text-neutral-900 wrap-break-word text-body-strong align-baseline">
                    {panel.title}
                  </p>
                  {expanded && panel.description && (
                    <p className="text-neutral-900 mt-space-200 text-left">{panel.description}</p>
                  )}
                </div>

                <div className="flex flex-row items-start gap-space-200 tablet:gap-space-400 pl-space-100 md:pl-0">
                  {index === 0 ? (
                    <>
                      <span className="w-16 tablet:w-20 flex flex-col items-center">
                        <CircleTickFilledIcon aria-hidden="true" />

                        <p className="mt-space-100 text-[10px] tablet:text-body-small text-neutral-900 text-center leading-tight">
                          Warranty period
                        </p>
                      </span>
                      <span className="w-16 tablet:w-20 flex flex-col items-center">
                        <CircleTickFilledIcon aria-hidden="true" />
                      </span>
                    </>
                  ) : (
                    <>
                      {panel?.additionalContent ? (
                        <span className="w-16 tablet:w-20 flex flex-col items-center text-neutral-500">
                          <CircleMinusIcon aria-hidden="true" />
                          <p className="mt-space-200 text-[10px] tablet:text-body-small text-neutral-900 text-center leading-tight">
                            {panel?.additionalContent}
                          </p>
                        </span>
                      ) : (
                        <span className="w-16 tablet:w-20 flex flex-col items-center text-neutral-500">
                          <CircleCrossSmallIcon aria-hidden="true" />
                        </span>
                      )}
                      <span className="w-16 tablet:w-20 flex flex-col items-center text-neutral-500">
                        <CircleTickFilledIcon aria-hidden="true" />
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
